/**
 * Converts DataGrid filter model to filter query string
 * Field and operator validation is handled by column configuration
 * Supports both AND and OR logic operators (Note: UI currently restricted to single conditions)
 * Uses headerName instead of field name in the filter query
 * Wraps all values in double quotes for proper API formatting
 * Dynamically maps DataGrid operators to query operators for extensibility
 */
export const convertFilterModelToQueryString = filterModel => {
    if (!filterModel || !filterModel.items || filterModel.items.length === 0) {
        return '';
    }

    // Define allowed filterable fields and their corresponding header names
    const fieldToHeaderMap = {
        firstName: 'FirstName',
        lastName: 'LastName',
        email: 'Email',
        status: 'Status',
    };

    // Define allowed operators (only equals)
    // const allowedOperators = ['equals', '='];

    // Map DataGrid operators to OData operators
    const operatorMap = {
        equals: 'eq',
        '=': 'eq',
        contains: 'contains',
        startsWith: 'startswith',
        endsWith: 'endswith',
        '>': 'gt',
        '>=': 'ge',
        '<': 'lt',
        '<=': 'le',
        '!=': 'ne',
        not: 'ne',
    };

    const filterParts = filterModel.items
        .map(item => {
            const { field, operator, value } = item;

            // Validate required properties
            if (!field || !operator || value === undefined || value === null || value === '') {
                return '';
            }

            // Format value with double quotes
            let formattedValue = value;
            if (typeof value === 'string') {
                formattedValue = `"${value}"`;
            } else if (typeof value === 'number') {
                formattedValue = `"${value.toString()}"`;
            } else if (typeof value === 'boolean') {
                formattedValue = `"${value.toString()}"`;
            }

            // Use header name instead of field name
            const headerName = fieldToHeaderMap[field];

            // Map the operator to the appropriate query operator
            const queryOperator = operatorMap[operator] || operator;

            // Build the filter expression using the selected operator
            return `${headerName} ${queryOperator} ${formattedValue}`;
        })
        .filter(Boolean);

    // Join with the logic operator (default to 'and', but support 'or' as well)
    const logicOperator = filterModel.logicOperator === 'or' ? 'or' : 'and';
    return filterParts.join(` ${logicOperator} `);
};
